<script>
  import BaseHeading from '../BaseHeading/BaseHeading.svelte';
  import { getPath } from '../../utils/imageKit.ts';

  let { headingText, headingLevel = 'h1', content, backgroundImage, dataTestId = 'masthead-promo' } = $props();

  // Handle Image Setup
  const smSrc = getPath(backgroundImage, { w: 180 });
  const mdSrc = getPath(backgroundImage, { w: 360 });
  const lgSrc = getPath(backgroundImage, { w: 360 }, 2);
</script>

<section data-testid={dataTestId} class="bg-blue-very-light py-8 lg:py-12">
  <div class="flex flex-col md:flex-row justify-between items-center max-w-6xl mx-auto px-4">
    <div class="markdown-wrapper prose w-full lg:pr-16 xl:pr-40 lg:max-w-none lg:text-lg no-underline">
      <BaseHeading
        {headingLevel}
        className="text-blue-dark-navy font-medium text-1.5xl md:text-2xl lg:text-4xl leading-tight mb-2 lg:mb-4"
      >
        {headingText}
      </BaseHeading>
      {@html content}
    </div>
    {#if backgroundImage && backgroundImage.url && backgroundImage.alt}
      <div class="hidden md:block w-1/3 lg:w-1/2 h-full">
        <img
          class="object-contain h-auto w-full"
          src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
          alt={backgroundImage.alt}
          width="187"
          height="135"
          srcset={`${'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=='} 1w, ${smSrc} 180w, ${mdSrc} 360w, ${lgSrc} 720w`}
          sizes="(min-width: 768px) 184px, (min-width: 1024px) 324px, (min-width: 1280px) 365px, 0vw"
        />
      </div>
    {/if}
  </div>
</section>
